import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import styled from 'styled-components';
import TextBox from 'components/ui/TextBox';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import DrawerFooter from 'components/ui/DrawerFooter';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerBody from 'components/ui/DrawerBody';

const StyledError = styled.div`
  display: block;
  color: ${colors.YUHU_RED};
`;

const ErrorContainer = styled.div`
  display: flex;
  align-items: baseline;
`;
const StyledCount = styled.p`
  color: ${props => (props.maxCount ? `${colors.YUHU_RED}` : `${colors.CHAR_COUNT}`)};
  margin: 0px;
  margin-top: 5px;
  margin-right: 5px;
`;

const StyledDenialConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
`;

const StyledFormRow = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const StyledFormInfo = styled.p`
  margin-bottom: 12px;
`;

const StyledFormItem = styled.div`
  width: 100%;
`;

const StyledTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const VIEW_APPROVAL_PAGE = 'view_approval_page';
const SUCCESS_DENIAL_PAGE = 'success_denial_page';

const DenialPurchaseOrderSchema = Yup.object().shape({
  denied_reason: Yup.string()
    .max(250, getTranslatedString('landlordPortal.denyPurchaseOrder.overCharLimit'))
    .required(getTranslatedString('required')),
});

export const DenyPurchaseOrderForm = props => {
  const {
    setApprovalState,
    denyPurchaseOrder,
    purchaseOrder,
    getPurchaseOrderStats,
    fetchPurchaseOrders,
    setToggleError,
    setIsUpdatingPurchaseOrder,
    getPurchaseOrder,
  } = props;
  return (
    <Formik
      initialValues={{
        denied_reason: '',
      }}
      validationSchema={DenialPurchaseOrderSchema}
      onSubmit={values => {
        setIsUpdatingPurchaseOrder(true);
        denyPurchaseOrder(values, purchaseOrder.id)
          .then(res => {
            getPurchaseOrder(purchaseOrder.id);
            fetchPurchaseOrders({
              updateList: true,
            });
            getPurchaseOrderStats();
            setIsUpdatingPurchaseOrder(false);
            setApprovalState(SUCCESS_DENIAL_PAGE);
          })
          .catch(err => {
            setToggleError(true);
            console.error(err);
          });
      }}
    >
      {({ values, setFieldValue, submitForm, validateForm, errors, touched }) => {
        return (
          <StyledDenialConfirmationContainer>
            <DrawerHeader
              onClose={() => setApprovalState(VIEW_APPROVAL_PAGE)}
              title={getTranslatedString('landlordPortal.denyPurchaseOrder.header')}
              subHeader={getTranslatedString('landlordPortal.purchaseOrderForm.indicates')}
            />
            <DrawerBody>
              <StyledFormInfo>
                {getTranslatedString('landlordPortal.denyPurchaseOrder.requiredIndicator')}
              </StyledFormInfo>
              <StyledFormRow>
                <StyledFormItem>
                  <StyledTextArea
                    name="denied_reason"
                    rows="3"
                    placeholder={getTranslatedString('landlordPortal.denyPurchaseOrder.enter')}
                    onChange={event => setFieldValue('denied_reason', event.currentTarget.value)}
                  />
                  <ErrorContainer>
                    <StyledCount maxCount={values.denied_reason.length > 250}>
                      {`${values.denied_reason.length}/250 ${getTranslatedString(
                        'landlordPortal.denyPurchaseOrder.characters'
                      )}`}{' '}
                    </StyledCount>
                    {errors.denied_reason && <StyledError>{errors.denied_reason}</StyledError>}
                  </ErrorContainer>
                </StyledFormItem>
              </StyledFormRow>
            </DrawerBody>
            <DrawerFooter
              primaryActionText={getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.deny')}
              onPrimaryActionClick={() => {
                validateForm(values).then(res => {
                  if (!('denied_reason' in res || 'additional_comments' in res)) {
                    submitForm();
                  }
                });
              }}
            />
          </StyledDenialConfirmationContainer>
        );
      }}
    </Formik>
  );
};
